import $ from 'jquery';

(function (A, U, $) {
  App.registerBehavior('ActionProgressOverlay', function (appSettings, settingsKey) {
    const settings = 'object' === typeof appSettings[settingsKey] && appSettings[settingsKey] || {
      action_data_attr: '',
      submit_form: true,
    };
    const submitForm = settings['submit_form'];
    const actionDataAttribute = 'string' === typeof settings.action_data_attr && settings.action_data_attr || '';
    if (0 < actionDataAttribute.length) {
      $('[data-' + actionDataAttribute + ']').once('ActionProgressOverlayBehavior').each(function () {
        const $element = $(this);
        const userEvent = 'string' === typeof $element.data(actionDataAttribute + '-user-event') && $element.data(actionDataAttribute + '-user-event') || 'click';
        $element.on(userEvent, function (e) {
          // Disable 'action' element (e.g. button)
          $(this).prop('disabled', true);
          // Submit the form (as this is not done due to disabled button)
          if (true === submitForm) {
            $(this).parents('form').trigger('submit');
          }
          // Show progress overlay
          A.progressOverlayShow();
        });
      });
    }
  }, U.lastOf(document.getElementsByTagName('script')).src);
}(App, Util, $));